import { Button, Form, Input, Modal } from "antd";
import { Col, Row } from "react-bootstrap";

// This value is interpolated directly into `href="${content.link}"` and
// inserted into the article's HTML body (see addAlsoRead in newform.tsx) —
// the same failure mode as pasting WhatsApp/headline text into TinyMCE's link
// dialog. Reject anything that isn't a clean URL or site-relative path before
// it ever reaches the editor, rather than relying solely on the render-side
// sanitizer to repair it later.
const validateLink = (_: any, value: string) => {
  if (!value) return Promise.reject(new Error("News Link is required"));
  const trimmed = value.trim();
  if (/\s/.test(trimmed)) {
    return Promise.reject(
      new Error("Link must be a single URL with no spaces or line breaks — don't paste headline text"),
    );
  }
  const isValidUrl =
    /^https?:\/\/[^\s"'<>]+$/i.test(trimmed) || /^\/[^\s"'<>]*$/.test(trimmed);
  if (!isValidUrl) {
    return Promise.reject(
      new Error("Enter a valid link, e.g. https://www.suprabhaatham.com/details/123 or /details/123"),
    );
  }
  return Promise.resolve();
};

export default function AlsoRead(props: any) {
  const [form] = Form.useForm();
  const onFinish = (val: any) => {
    props.onSubmit(val);
    props.close();
  };
  return (
    <Modal
      title={<div style={{ textAlign: "center" }}>Also Read</div>}
      open={props.visible}
      onCancel={() => props.close()}
      style={{ top: 20 }}
      width={500}
      footer={false}
    >
      <Row>
        <Form form={form} onFinish={onFinish}>
          <Col md={24}>
            <div className="newsFormLabels">News Link</div>
            <Form.Item name="link" rules={[{ validator: validateLink }]} validateTrigger="onSubmit">
              <Input placeholder="https://www.suprabhaatham.com/details/123" />
            </Form.Item>
            <div className="newsFormLabels">Preffered Content</div>
            <Form.Item name="content">
              <Input />
            </Form.Item>
            <Button
              className="hmScrn-SaveEditBtn"
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
          </Col>
        </Form>
      </Row>
    </Modal>
  );
}
